import { useNavigate } from "react-router";
import { StatePrompts } from "../../components/statePrompts/statePrompts";
import { BUYERS } from "../../constants/routes";
import { CustomerPaymentFilterType } from "./customerList/CustomerListFilterTypes";

export const CustomerListStatePrompts = ({
  searchValue,
  filterValue,
  setFilterValue,
  setSearchValue,
  customersLength,
  emptySearch,
  callback,
}: {
  searchValue?: string;
  filterValue?: string;
  setFilterValue: (value: CustomerPaymentFilterType) => void;
  setSearchValue: (value: string) => void;
  customersLength: number;
  emptySearch?: boolean;
  callback?: () => void;
}) => {
  const navigate = useNavigate();
  let title: string | undefined;
  let description: string | undefined;
  let cta: string | undefined;
  let tertiaryCta: string | undefined;

  if (!customersLength && !searchValue && !filterValue && !emptySearch) {
    title = "Invite customers to join your trade store.";
    description =
      "They’ll receive an email to access your store with the pricing and terms you pre-assign to them. You’ll even be able to place orders on their behalf";
    cta = "Invite customers";
  } else {
    title = customersLength
      ? "Don’t see who you’re looking for?"
      : filterValue
        ? `Couldn’t find any customers ${filterValue}`
        : `Couldn’t find ${searchValue} in your customer list `;
    tertiaryCta =
      filterValue || searchValue
        ? filterValue
          ? "Remove filter"
          : "Remove search term"
        : undefined;
    description = !!(searchValue || filterValue)
      ? `Try searching all venues across Sellar or remove the current ${
          filterValue ? "filter" : "search term"
        }`
      : "Try searching all venues across Sellar";
    cta = "Search all of Sellar";
    if (emptySearch) {
      title = "Your search returned 0 customers";
      description =
        "Were you expecting to see customers which fit this criteria? Try searching all venues across Sellar, or remove these filters to start a new search.";
      tertiaryCta = "Remove filter(s)";
    }
  }

  return (
    <>
      {title && (
        <StatePrompts
          onClickTertiary={() => {
            setSearchValue("");
            setFilterValue("customers");
            callback?.();
          }}
          onClick={() => navigate(BUYERS)}
          title={title}
          description={description}
          primaryCta={cta}
          tertiaryCta={tertiaryCta}
        />
      )}
    </>
  );
};
